




















































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import {
  Lang, Skill,
} from '@/store/types';
import BbTools from '@/tools/bluebird';
import LearningTools from '@/tools/learning';
import UserTools from '@/tools/user';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  name: 'Welcome',
  data() {
    return {
      langL: this.$store.state.langL,
    };
  },
  mounted(): void {
    this.$store.commit('setMainLoading', false);
  },
  watch: {
    '$store.state.langI': function (value) {
      if (!this.$store.state.langL) {
        this.$store.commit('setMainLoading', false);
      }
    },
    '$store.state.langL': function (value) {
      this.langL = this.$store.state.langL;
      this.$store.commit('setMainLoading', false);
    },
  },
  computed: {
    ...mapGetters([
      'lessonLast',
      'lessonLastPersonalized',
    ]),
    showLessonLast(): boolean {
      if (!this.lessonLast) {
        return false;
      }
      if (this.$store.state.langI.id !== this.lessonLast.lang_i) {
        return false;
      }
      if (UserTools.isOneLanguageSubscription()
        && this.$store.state.user.subscription.lang_l !== this.lessonLast.lang_l) {
        return false;
      }
      return true;
    },
    showLessonLastPersonalized(): boolean {
      if (!this.lessonLastPersonalized) {
        return false;
      }
      if (this.$store.state.langI.id !== this.lessonLastPersonalized.lang_i) {
        return false;
      }
      if (UserTools.isOneLanguageSubscription()
        && this.$store.state.user.subscription.lang_l !== this.lessonLastPersonalized.lang_l) {
        return false;
      }
      return true;
    },
    lessonLastImage(): string {
      if (this.showLessonLast) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        if (this.lessonLast.level_id.toString() === LearningTools.LEVEL_DAILY_LESSONS) {
          const lessonSkill = this.$store.state.skills
            .find((skill: Skill) => skill.label === this.lessonLast.unit_label);
          return LearningTools
            .getUnitDailyIconSource(this.$store, lessonSkill ? lessonSkill.order : 1);
        }
        const image = `${this.$store.getters.ipLearn}/files/images/bb/levels/`;
        return `${image}${this.lessonLast.lang_l}-${this.lessonLast.level_id}-hq.jpg${BbTools.APP_POSTFIX}`;
      }
      return '';
    },
    lessonLastPersonalizedImage(): string {
      if (this.showLessonLastPersonalized) {
        const image = `${this.$store.getters.ipLearn}/files/images/bb/levels/`;
        return `${image}${this.lessonLastPersonalized.lang_l}-p-hq.jpg${BbTools.APP_POSTFIX}`;
      }
      return '';
    },
  },
  methods: {
    async langLChanged(langL: Lang): Promise<void> {
      this.$store.commit('setMainLoading', true);
      await LearningTools.setNewLangIL(this.$store, this.$store.state.langI.id, langL.id);
      await this.$router.push(RoutePaths.LEVELS);
    },
    async onContinue(): Promise<void> {
      this.$store.commit('setMainLoading', true);
      await LearningTools.setNewLangIL(this.$store, this.$store.state.langI.id, this.langL.id);
      await this.$router.push(RoutePaths.LEVELS);
    },
    async onLessonLast(): Promise<void> {
      LearningTools.loadLesson(this.$store, this.$router, this.lessonLast);
    },
    async onLessonLastPersonalized(): Promise<void> {
      LearningTools.loadLesson(this.$store, this.$router, this.lessonLastPersonalized);
    },
  },
});

